module.exports = __webpack_public_path__ + "static/media/karta_karta.616774a1.jpg";